import { Component, Input } from '@angular/core';

import { SedsButtonTypeOptions } from '../../seds-buttons/enums/seds-button-type-options.enum';
import { SedsPositionsOptions } from '../../../shared/enums/seds-positions-options.enum';
import { SedsPositionsOptionsType } from '../../../shared/types/seds-positions-options.type';
import { SedsSizeOptions } from '../../../shared/enums/seds-size-options.enum';
import { SedsSizeOptionsType } from '../../../shared/types/seds-size-options.type';
import { SedsButtonOptionsType } from './../types/seds-button-options.type';

@Component({
    selector: 'seds-core-button',
    templateUrl: './seds-core-button.component.html',
    styleUrls: ['./seds-core-button.component.scss'],
    standalone: false
})
export class SedsCoreButtonComponent {
  @Input()
  color = '';
  @Input()
  disabled = false;
  @Input()
  iconName = '';
  @Input()
  iconPosition: SedsPositionsOptions | SedsPositionsOptionsType = SedsPositionsOptions.LEFT;
  @Input()
  loading = false;
  @Input()
  size: SedsSizeOptions | SedsSizeOptionsType = SedsSizeOptions.STANDARD;
  @Input()
  title = '';
  @Input()
  type: SedsButtonTypeOptions | SedsButtonOptionsType = SedsButtonTypeOptions.BASIC;
  @Input()
  width = '';

  readonly typeBasic = SedsButtonTypeOptions.BASIC;
  readonly typeFlat = SedsButtonTypeOptions.FLAT;
  readonly typeOulined = SedsButtonTypeOptions.OUTLINED;
  readonly typeFab = SedsButtonTypeOptions.FAB;

  readonly sizeLarge = SedsSizeOptions.LARGE;

  readonly iconRight = SedsPositionsOptions.RIGHT;
  readonly iconLeft = SedsPositionsOptions.LEFT;
}
